module.exports = __webpack_public_path__ + "static/img/7.cd679d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/7.png
// module id = 8OQp
// module chunks = 0